module.exports = __webpack_public_path__ + "static/img/inviteNow.c383fcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/inviteNow.png
// module id = 7qZh
// module chunks = 0